import React from 'react';

const About: React.FC = () => {
    return(
        <p>about</p>
    )
};

export default About;